import { Box } from '@mantine/core'
import clsx from 'clsx'
import React, { type PropsWithChildren } from 'react'

import { Cancel } from './Cancel'
import { Close } from './Close'
import { Content } from './Content'
import { FooterExtra } from './FooterExtra'
import { useFilterChildren } from './hooks/useFilterChildren'
import { Icon } from './Icon'
import classes from './styles.module.css'
import { Submit } from './Submit'
import { Subtitle } from './Subtitle'
import { Title } from './Title'
import { WrapperBody } from './WrapperBody'
import { WrapperFooter } from './WrapperFooter'
import { WrapperHeader } from './WrapperHeader'

export type ModalProps = PropsWithChildren & {
  className?: string
  variant?: 'default' | 'confirmation'
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
}

export function Modal({
  children,
  size = 'md',
  variant = 'default',
  className,
  ...props
}: ModalProps) {
  const { headerChildren, footerChildren, contentChildren } =
    useFilterChildren(children)

  const modalClasses = clsx(className, classes.modal, classes[size], {
    [classes.modalConfirmation]: variant === 'confirmation',
  })

  return (
    <Box
      className={modalClasses}
      onClick={(e) => e.stopPropagation()}
      {...props}
    >
      {headerChildren && <WrapperHeader>{headerChildren}</WrapperHeader>}
      {contentChildren && <WrapperBody>{contentChildren}</WrapperBody>}
      {footerChildren && <WrapperFooter>{footerChildren}</WrapperFooter>}
    </Box>
  )
}

Modal.Icon = Icon
Modal.Title = Title
Modal.Subtitle = Subtitle
Modal.Content = Content
Modal.Cancel = Cancel
Modal.Close = Close
Modal.Submit = Submit
Modal.FooterExtra = FooterExtra
